import { DON_D_LOGO_URL, VENAQQI_LOGO_URL } from "./brandAssets";

export default function FeedbackBrand() {
  return (
    <div aria-label="Venaqqi y Don D’" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, margin: "0 auto 20px" }}>
      <span style={{ width: 62, height: 50, borderRadius: 12, border: "1px solid #353535", background: "#080808", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
        <img src={VENAQQI_LOGO_URL} alt="Venaqqi" style={{ display: "block", width: 56, height: 44, objectFit: "contain" }} />
      </span>
      <span aria-hidden="true" style={{ color: "#666", fontSize: 18, fontWeight: 300 }}>+</span>
      <span className="don-d-logo-shell" style={{ width: 50, height: 50, borderRadius: "50%", border: "1px solid #e53935", background: "#080808", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
        <img className="don-d-logo-symbol" src={DON_D_LOGO_URL} alt="Don D’" style={{ display: "block", width: 44, height: 44, borderRadius: "50%", objectFit: "contain" }} />
      </span>
    </div>
  );
}
